import React, { useEffect } from 'react'
import Services from '../components/services'
import Experience from '../components/experiance'
import NewServices from '../components/newservises'

export default function Service() {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  return (
    <div className='py-10'>
      {/* <Services /> */}
      <NewServices />
      <Experience />
    </div>
  )
}
